export default __webpack_public_path__ + "ad3a0d26b3f4c278f08a7535e33211c6.jpg";